var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"ml-3 h4 cursor-pointer",attrs:{"data-placement":"left","data-toggle":"tooltip","data-trigger":"hover","data-original-title":_vm.inWishlist
                ? _vm.dataTexts.remove_from_wishlist
                : _vm.dataTexts.add_to_wishlist},on:{"click":function($event){return _vm.toggleWishlist()}}},[_c('i',{class:{
                'icon-line-bookmark':
                    !_vm.inWishlist,
                'icon-bookmark21': _vm.inWishlist,
            }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }